import { Boundaries } from "@planzone/core";
import { group, id } from "@planzone/dto";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  group: Boundaries["removeResourceGroup"]["request"],
): State {
  const index = state.findIndex((req) => req.group.uuid === group.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { group, requestState: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { group, requestState: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  group: Boundaries["removeResourceGroup"]["success"],
): State {
  const index = state.findIndex((req) => req.group.uuid === group.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { group, requestState: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { group, requestState: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  group: Boundaries["removeResourceGroup"]["failure"],
): State {
  const index = state.findIndex((req) => req.group.uuid === group.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { group, requestState: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { group, requestState: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeResourceGroupRequested]: handleRequest,
    [events.removeResourceGroupSucceeded]: handleSuccess,
    [events.removeResourceGroupFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
